// utils/token.js
import {secureSessionStorage } from "store/SecureStorage";

export const getToken = () => secureSessionStorage.get('_aut');
export const setToken = (token) => secureSessionStorage.set('_aut', token);

